// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"78cff296","137":"b0866a40","149":"c697515c","346":"cd8ae094","388":"2d4f3306","453":"ac1a9c99","475":"ecf280e8","741":"7c3090ba","761":"cdc0218f","799":"01977415","819":"3fb30506","918":"a092d275","919":"1f181bc1"}[chunkId] + ".chunk.js";
};